import { render, staticRenderFns } from "./diyspecial.vue?vue&type=template&id=3af5c35d&scoped=true&"
import script from "./diyspecial.vue?vue&type=script&lang=js&"
export * from "./diyspecial.vue?vue&type=script&lang=js&"
import style0 from "./diyspecial.vue?vue&type=style&index=0&id=3af5c35d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af5c35d",
  null
  
)

export default component.exports